<template>
  <div class="shareModal">

      <div class="shareImage">
        <img v-bind:src="getImage()">
      </div> <!-- shareImage -->

      <div class="title">
       {{ $t('shareTitle') }}
      </div> <!-- title -->

      <!--<div class="buttons">
        <div v-on:click="share('fb')" class="facebookShare shareButton"><i class="icon-facebook"></i></div>
        <!--<div v-on:click="share('instagram')" class="instagramShare shareButton"><i class="icon-instagram"></i></div>
        <div v-on:click="share('pinterest')" class="pinterestShare shareButton"><i class="icon-pinterest"></i></div>
        <div v-on:click="share('twitter')" class="twitterShare shareButton"><i class="icon-twitter"></i></div>
        <div v-on:click="share('email')" class="mailShare shareButton"><i class="fa fa-envelope"></i></div>
      </div> -->

      <!--<div class="link">
        <span class="linkheading"> <i class="fa fa-link"></i> {{ $t('linkToWall') }}  </span>
        <input id="shareLinkToCopy" v-bind:value="currentWallUrl" type="text">
        <div v-on:click="copyLink" class="button"> <i v-if="copied" class="fa fa-check"></i>  {{ $t('copy') }} </div>
      </div> <!-- link -->

  </div> <!-- shareModal -->
</template>

<script>

export default {
  data: function(){
    return{
      copied: false,
    }
  },

  props: ['messageData'],

  computed: {
    currentWallUrl(){
        var url = window.location.href
        var arr = url.split("/")
        var domain = arr[0] + "//" + arr[2]
        return domain + this.$store.state.currentWallURL
      }
  },

  methods: {
      getImage(){
        return window.appSettings.imageCloudUrl + this.$store.state.wallPicture;
      },

      getUrl(){
        var url = window.location.href;
        url = url.substring(0, url.indexOf('#')) + "#";
        return url + "?saved_id="+this.$store.state.currentWallID+"&c_id=" + this.$store.state.pictureWall.configurator_id;
      },

      copyLink(){
        var copyTextField = $("#shareLinkToCopy");
        copyTextField.select();
        document.execCommand('copy');
        this.copied = true;
      },

      share(method){

        var self = this;
        var link = "";
        var image = self.getImage()

        switch(method){

          case 'fb':
            link = "https://www.facebook.com/sharer.php?u=" + self.currentWallUrl;
            break;
          case 'instagram':
            link = "https://www.facebook.com/sharer.php?u=" + self.currentWallUrl;
            break;
          case 'pinterest':
            link = "http://pinterest.com/pin/create/button/?url="+encodeURI(self.currentWallUrl);+"&media="+ encodeURI(image);
            break;
          case 'twitter':
            link = "http://twitter.com/share?="+self.currentWallUrl+"&hashtags=desenio";
            break;
          case 'email':
            link = "mailto:?body=" + self.currentWallUrl;
            break;

        }

        window.open(link,'_blank');

      }

  },

  mounted: function () {


  }

}
</script>

<style lang="scss">

.shareModal{

  .title{
    margin-top: 15px;
  }

  .buttons{
    text-align: center;
    margin-top: 35px;
    display: flex;
    justify-content: center;
  }

  /* Social buttons */
  .shareButton{
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-height: 50px;
    min-width: 50px;
    font-size: 23px;
    color: white;
    cursor: pointer;
    background: black;
    margin-right: 8px;
    border-radius: 100%;

    &:last-of-type{
      margin-right: 0;
    };

    &:hover{
      opacity: 0.8;
    }
    .fa-envelope { position: relative; top: -1px; }
  }

  /* Link */
  .link{
    text-align: center;
    margin-top: 30px;

    .linkheading{
      font-family: "Raleway", "Helvetica Neue", "Helvetica", Arial, sans-serif;
      font-weight: 500;
      text-transform: uppercase;
      font-size: 15px;
      display: block;
    }

    input{
      display: inline-block;
      margin-top: 15px !important;
      margin: auto;
    }

    .button{
      position: relative;
      top: -2px;
      color: white;
    }

  }

  .shareImage{
    height: 0;
    padding-bottom: 59%;
    overflow: hidden;

     /* Mobile */
    @media screen and (max-width: 812px) {
      display: none;
    }

    img{
      width: 100%;
    }
  }
}

</style>



// WEBPACK FOOTER //
// Share.vue?1f795046